// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__se8aR","notes":"Notes_notes__hGVT_"};